<template>
  <section class="benefits">
    <div class="container">
      <h2 class="section-title">Why Choose Cookie Cutter?</h2>
      <p class="section-subtitle">Experience the web the way it should be</p>

      <div class="benefits-grid">
        <!-- Benefit 1: Save Time -->
        <div class="benefit-card">
          <div class="benefit-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
          </div>
          <h3 class="benefit-title">Save Time</h3>
          <p class="benefit-description">
            Our users have collectively saved thousands of hours by not clicking cookie banners. If manually consenting takes 4 seconds, you'll save hours per year.
          </p>
          <div class="benefit-stat">
            <span class="stat-number">10,000+</span>
            <span class="stat-label">hours saved collectively</span>
          </div>
        </div>

        <!-- Benefit 2: Enhanced Privacy -->
        <div class="benefit-card">
          <div class="benefit-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              <path d="M9 12l2 2 4-4"/>
            </svg>
          </div>
          <h3 class="benefit-title">Enhanced Privacy</h3>
          <p class="benefit-description">
            Automatically reject tracking cookies and protect your privacy across the web. Your preferences are enforced consistently on every website you visit.
          </p>
          <div class="benefit-stat">
            <span class="stat-number">GDPR</span>
            <span class="stat-label">compliant protection</span>
          </div>
        </div>

        <!-- Benefit 3: Zero Data Collection -->
        <div class="benefit-card">
          <div class="benefit-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <h3 class="benefit-title">Zero Data Collection</h3>
          <p class="benefit-description">
            We don't collect, store, or transmit any of your personal data. Your preferences stay on your device. 100% open-source and verifiable.
          </p>
          <div class="benefit-stat">
            <span class="stat-number">0</span>
            <span class="stat-label">data collected from you</span>
          </div>
        </div>
      </div>

      <!-- CTA Section -->
      <div class="benefits-cta">
        <h3 class="cta-title">Ready to reclaim your browsing experience?</h3>
        <a href="#CookieCutter" class="btn-cta">
          Get Started Free
          <svg class="cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BenefitsSection"
};
</script>

<style scoped>
.benefits {
  background-color: rgba(40, 54, 60, 0.5);
  backdrop-filter: blur(7px);
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
  padding: 60px 20px;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  color: #e8ae1b;
  font-size: clamp(32px, 4.5vw, 42px);
  font-weight: 700;
  margin: 0 0 12px 0;
}

.section-subtitle {
  text-align: center;
  color: rgba(254, 254, 254, 0.8);
  font-size: clamp(16px, 1.8vw, 18px);
  margin: 0 0 50px 0;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.benefit-card {
  background: rgba(40, 54, 60, 0.6);
  border-radius: 16px;
  padding: 35px 25px;
  border: 2px solid rgba(232, 174, 27, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.benefit-card:hover {
  transform: translateY(-8px);
  border-color: rgba(232, 174, 27, 0.5);
  background: rgba(40, 54, 60, 0.8);
  box-shadow: 0 12px 32px rgba(232, 174, 27, 0.2);
}

.benefit-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(232, 174, 27, 0.25) 0%, rgba(232, 174, 27, 0.1) 100%);
  border-radius: 16px;
  margin-bottom: 24px;
  border: 2px solid rgba(232, 174, 27, 0.3);
  transition: all 0.3s ease;
}

.benefit-card:hover .benefit-icon {
  background: linear-gradient(135deg, rgba(232, 174, 27, 0.35) 0%, rgba(232, 174, 27, 0.15) 100%);
  border-color: rgba(232, 174, 27, 0.5);
  transform: scale(1.1) rotate(5deg);
}

.benefit-icon svg {
  width: 36px;
  height: 36px;
  color: #e8ae1b;
}

.benefit-title {
  font-size: clamp(20px, 2.5vw, 24px);
  font-weight: 600;
  color: #fefefe;
  margin: 0 0 14px 0;
  line-height: 1.3;
}

.benefit-description {
  font-size: clamp(14px, 1.6vw, 16px);
  color: rgba(254, 254, 254, 0.8);
  line-height: 1.7;
  margin: 0 0 20px 0;
  flex-grow: 1;
}

.benefit-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 20px;
  background: rgba(232, 174, 27, 0.1);
  border-radius: 12px;
  width: 100%;
  border: 1px solid rgba(232, 174, 27, 0.2);
}

.stat-number {
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 700;
  color: #e8ae1b;
  line-height: 1;
  margin-bottom: 6px;
  font-family: Inter, Arial, sans-serif;
}

.stat-label {
  font-size: clamp(12px, 1.4vw, 14px);
  color: rgba(254, 254, 254, 0.7);
  line-height: 1.3;
}

/* CTA Section */
.benefits-cta {
  text-align: center;
  padding: 40px 20px;
  background: rgba(40, 54, 60, 0.6);
  border-radius: 20px;
  border: 2px solid rgba(232, 174, 27, 0.3);
}

.cta-title {
  font-size: clamp(22px, 3vw, 28px);
  font-weight: 600;
  color: #fefefe;
  margin: 0 0 24px 0;
  line-height: 1.4;
}

.btn-cta {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #e8ae1b 0%, #f3c14c 100%);
  color: #28363c;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(232, 174, 27, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn-cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(232, 174, 27, 0.4);
  color: #28363c;
}

.btn-cta:hover::before {
  opacity: 1;
}

.btn-cta:active {
  transform: translateY(-1px);
}

.cta-arrow {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.btn-cta:hover .cta-arrow {
  transform: translateX(4px);
}

/* Responsive Design */
@media (min-width: 768px) and (max-width: 1100px) {
  .benefits-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .benefits {
    padding: 40px 20px;
  }

  .section-subtitle {
    margin-bottom: 40px;
  }

  .benefits-grid {
    gap: 25px;
    margin-bottom: 40px;
  }

  .benefit-card {
    padding: 30px 20px;
  }

  .benefits-cta {
    padding: 30px 20px;
  }
}

@media (max-width: 500px) {
  .benefits {
    padding: 30px 16px;
  }

  .benefit-icon {
    width: 60px;
    height: 60px;
  }

  .benefit-icon svg {
    width: 30px;
    height: 30px;
  }

  .btn-cta {
    padding: 14px 28px;
    font-size: 16px;
  }
}
</style>
